import React from "react";
import { LoginForm } from "../../components/Auth";
import "./Auth.css";

export function Auth() {
  return (
    <div className="sign-in-Page">
      <div className="auth-shell">
        <section className="auth-visual" aria-label="Pothole Repair">
          <div className="auth-visual__content">
            <div className="auth-visual__accent" />
            <div className="auth-visual__copy">
              <p className="auth-visual__eyebrow">Customer Portal</p>
              <h1 className="auth-visual__title">Pothole Repair</h1>
              <p className="auth-visual__tagline">The Fix Is In</p>
            </div>
          </div>
        </section>

        <section className="auth-panel">
          <LoginForm />
        </section>
      </div>
    </div>
  );
}
